module.exports = __webpack_public_path__ + "img/franjas-envios.fa7b41c5.jpg";